
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nederland-tcs",
      function () {
        return require("private-next-pages/nederland-tcs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nederland-tcs"])
      });
    }
  